export const environment = {
  production: false,
  SMART_LICENSE_KEY: '575F232B-93C7-4D9B-AD15-296DB0C585BE',
  CRG_DIGITALIZATION_SERVICE_URL: 'https://stage.apps.thermofisher.com/api',
  USER_DETAILS_URL: 'https://stage.apps.thermofisher.com/dhap-amp/api/v2/user/userDetails',
  ENTITLEMENTS_URL:
    'https://stage.apps.thermofisher.com/api/de-eec-subscription/v1/user/entitlements',
  CRG_HOME: 'https://clinical-decision-suite.stage.apps.thermofisher.com/home',
  KPI_CHART_DATA_TIMEOUT: 7000
};

export const featureFlags = {
  enableUserSessionMonitoring: true,
  enableStudyInsights: false,
  enableStudyInsightsVariants: false,
  hiddenKPIs: [
    'lab_sample_query_rate',
    'ereq_usage_for_lab_samples',
    'lab_kits_shipped',
    'lab_kit_wastage'
  ],
  hiddenDrilldownCharts: [
    'enrollment',
    'earlyterm',
    'deviation_rate_per_subject',
    'crf_review_completed',
    'clinical_material_kits_shipped',
    'on_time_dispatch_clinical_materials',
    'source_data_verification'
  ]
};
